import { PollingStatus, StatusProvider } from '@/tax/models';

export type ProgressModel = { progress: number };

export enum SyncEntityType {
    ExactOnline = 'ExactOnline',
    Yuki = 'Yuki',
    Odoo = 'Odoo',
}

export class DepreciationSync {
    id = -1;
    periodId = -1;
    reconciliationId = 1;
    syncReference = '';
    accountancySynchronisationEntityType: string = SyncEntityType.ExactOnline;
    accounts: number[] = [];
    importAttachments = false;
    organisationId = -1;
    companyId = -1;
    transactionAmount = -1;
    createdAt = new Date();
    endDate?: Date;
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    progress = 0;
    cutoffDate?: Date;
    workflowId?: number;


    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.reconciliationId = data.reconciliation_text_id ?? data.reconciliation_id ?? 1;
        this.syncReference = data.sync_reference ?? '';
        this.accountancySynchronisationEntityType = data.accountancy_synchronisation_entity_type ?? SyncEntityType.ExactOnline;
        this.importAttachments = data.import_attachments ?? false;
        this.accounts = data.accounts ?? [];
        this.organisationId = data.organisation ?? -1;
        this.companyId = data.company ?? -1;
        this.transactionAmount = data.transaction_mount ?? -1;
        this.createdAt = data.created_at ?? new Date();
        this.endDate = data.end_date ?? undefined;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.progress = data.progress ?? 0;
        this.cutoffDate = data.cutoff_date ? new Date(data.cutoff_date) : undefined;
        this.workflowId = data.workflow_id ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            period_id: this.periodId,
            reconciliation_id: this.reconciliationId,
            sync_reference: this.syncReference,
            accountancy_synchronisation_entity_type: this.accountancySynchronisationEntityType,
            accounts: this.accounts,
            import_attachments: this.importAttachments,
            cutoff_date: this.cutoffDate?.toISOString() || null,
        };
    }
}
